export default __webpack_public_path__ + "static/media/arivaone5.98808174.jpg";